import React, { useState } from 'react';
import classNames from 'classnames';

import { Collapse } from '@alfalab/core-components/collapse';
import { Space } from '@alfalab/core-components/space/cssm';
import { Typography } from '@alfalab/core-components/typography';
import { ChevronDownMIcon } from '@alfalab/icons-glyph/ChevronDownMIcon';

import styles from './collapse-block.module.css';

export const CollapseBlock = ({
    title,
    children,
    isOpen = false,
}: {
    title: string;
    children: string | JSX.Element | JSX.Element[];
    isOpen?: boolean;
}) => {
    const [expanded, setExpanded] = useState(isOpen);
    const onClick = () => {
        setExpanded(!expanded);
    };

    return (
        <Space direction='vertical' size={26} fullWidth={true}>
            <div
                className={classNames(styles.root, { [styles.open]: expanded })}
                onClick={onClick}
                aria-hidden={true}
            >
                <Typography.Text view='component' weight='bold'>
                    {title}
                </Typography.Text>
                <ChevronDownMIcon className={styles.chevron} />
            </div>
            <Collapse expanded={expanded}>{children}</Collapse>
        </Space>
    );
};
